import React, { useRef } from 'react';
import { motion, useTransform } from 'framer-motion';
import { useSectionProgress } from './useSectionProgress';

const PILLARS = [
  { n: '01', title: 'Posicionamento', line: 'O que faz você ser lembrado.', text: 'Descobrimos o que só a sua empresa tem e transformamos isso em uma mensagem clara, que separa você da concorrência e tira a conversa do preço.', practice: 'Narrativa · Identidade · Discurso de marca' },
  { n: '02', title: 'Percepção', line: 'Como o mercado enxerga você.', text: 'A sua imagem precisa estar à altura do seu serviço. Produção audiovisual de nível cinema, pensada para gerar desejo e confiança no público certo.', practice: 'Filmagem · Fotografia · Aéreas · Direção' },
  { n: '03', title: 'Presença', line: 'Onde o cliente decide.', text: 'Seu perfil, seu site e seus anúncios trabalhando juntos, com constância, para que a sua empresa seja a primeira lembrada e a mais fácil de contratar.', practice: 'Instagram · Site · Campanhas · Rotina' },
];

const Card = ({ p, i, progress }) => {
  const s = i / PILLARS.length;
  const e = (i + 1) / PILLARS.length;
  const y = useTransform(progress, [s - 0.25, s], ['110vh', '0vh']);
  const rotX = useTransform(progress, [s - 0.25, s, e, e + 0.2], [35, 0, 0, -8]);
  const scale = useTransform(progress, [s, e + 0.2], [1, 0.92]);
  return (
    <motion.article
      style={{ y: i === 0 ? 0 : y, rotateX: i === 0 ? 0 : rotX, scale, top: `${i * 22}px`, height: 'calc(100% - 44px)' }}
      className="absolute inset-x-0 mx-auto max-w-4xl rounded-[28px] border border-white/10 bg-[#141B23] bg-gradient-to-br from-[#18202A] to-[#0F141A] p-6 sm:p-12 shadow-[0_-30px_80px_-30px_rgba(0,0,0,0.9)] origin-top overflow-hidden"
      data-testid={`pillar-${p.n}`}
    >
      <div className="flex items-start justify-between gap-6">
        <span className="br-serif text-6xl sm:text-8xl font-semibold text-[#4ECDC4]/90 leading-none">{p.n}</span>
        <span className="br-mono text-[10px] text-[var(--br-muted)] text-right pt-3">{p.line}</span>
      </div>
      <h3 className="mt-6 text-4xl sm:text-6xl font-semibold">{p.title}</h3>
      <p className="mt-5 text-base sm:text-lg text-[var(--br-muted)] max-w-2xl leading-relaxed">{p.text}</p>
      <p className="mt-8 pt-6 border-t border-white/10 text-sm text-white/80"><span className="br-mono text-[10px] text-[var(--br-amber)] mr-3">Na prática</span>{p.practice}</p>
    </motion.article>
  );
};

export const Method3D = () => {
  const ref = useRef(null);
  const scrollYProgress = useSectionProgress(ref);
  return (
    <section id="metodo" ref={ref} className="relative h-[320vh] bg-[var(--br-bg)]" data-testid="method-section">
      <div className="sticky top-0 h-screen overflow-hidden br-perspective flex flex-col justify-center px-5 sm:px-8">
        <div className="mx-auto max-w-4xl w-full mb-10">
          <p className="br-mono text-[11px] text-[var(--br-teal)]">O Método 3P</p>
          <h2 className="mt-4 text-3xl sm:text-5xl font-semibold">Três pilares. <span className="italic text-white/60">Uma marca impossível de ignorar.</span></h2>
        </div>
        <div className="relative mx-auto w-full max-w-4xl h-[66vh] sm:h-[54vh]">
          {PILLARS.map((p, i) => <Card key={p.n} p={p} i={i} progress={scrollYProgress} />)}
        </div>
      </div>
    </section>
  );
};
